<template>
    <div style="margin-bottom:15px;margin-top:15px;">
        <div v-for="model in question.answers" v-bind:key="model.uid">
            <label
                    :for="question.uid" v-bind:class="{ selected: model.selected }">
            </label>

            <image-uploader
                    :debug="1"
                    :quality="0.7"
                    outputFormat="string"
                    :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                    accept="image/jpg, image/jpeg, image/png"
                    doNotResize="['gif', 'svg', 'png', 'jpg', 'jpeg']"
                    @input="setImage($event, model)"
                    @onUpload="onUpload"
                    @onComplete="onComplete"
            >
            </image-uploader>
            <input type="hidden" v-model="model.value" class="form-control" :placeholder="model.title" :name="question.uid">
        </div>
    </div>
</template>

<script>
    import ImageUploader from 'vue-image-upload-resize'

    export default {
        name: 'image-upload',
        props: ['question'],
        data() {
            return {
                hasImage: false
            }
        },
        methods: {
            setImage: function (e, model) {
                this.hasImage = true;
                model.value = e;
                console.log(model)
            },
            onUpload: function () {
            },
            onComplete: function () {
            },
        },
        components: {
            ImageUploader
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }

    .img-preview {
        width: 100px;
    }
</style>
